import { ViewModeSelect } from "../../../../components/Dashboards/ViewModeSelect/ViewModeSelect";
import { DashBoardViewProvider } from "../../../../store/contexts/DashBoardViewContext";
import { DashboardViewContainer } from "./DashboardViewContainer/DashboardViewContainer";
interface IDashBoardPanelsPageProps {
  isView?: boolean;
}

const DashBoardPanelsPage: React.FC<IDashBoardPanelsPageProps> = ({
  isView = false,
}) => {
  return (
    <DashBoardViewProvider isView={isView}>
      <ViewModeSelect />
      <DashboardViewContainer />
    </DashBoardViewProvider>
  );
};

export default DashBoardPanelsPage;
